import React, { Fragment, Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { keys } from 'mobx';
import { observer } from 'mobx-react';
import { isAlive } from 'mobx-state-tree';
import { Select, Input, Row } from 'antd';
import { SettingsFormHeader } from '../../../../common/SettingsFormHeader';
import { FormItem } from '../../styled';
import { config } from '../../config';
import Button from '../../../../common/Button';

const { Option } = Select;

@injectIntl
@observer
export default class ReturnForm extends Component {
  constructor(props) {
    super(props);
    this.handlePolicy = this.handlePolicy.bind(this);
  }
  componentWillUnmount() {
    const { ebayReturnPolicies } = this.props;
    if (isAlive(ebayReturnPolicies)) {
      ebayReturnPolicies.cancelFormSelection();
    }
  }

  handlePolicy() {
    const { ebayReturnPolicies, isCreateAction, close } = this.props;
    if (isCreateAction) {
      ebayReturnPolicies.createNewPolicy().then(() => close());
    } else {
      ebayReturnPolicies.handlePolicy();
    }
  }

  render() {
    const formItemLayout = config.editPolicyItemLayout;
    const { ebayReturnPolicies, isCreateAction, intl, close } = this.props;
    const {
      setPolicyName,
      name,
      setInternationalDays,
      internationalDays,
      setDomesticDays,
      domesticDays,
      isButtonDisabled,
      returnPolicyList,
    } = ebayReturnPolicies;
    return (
      <Fragment>
        <SettingsFormHeader id="listing.returns" defaultMessage="RETURNS" />
        <FormItem
          {...formItemLayout}
          label={<FormattedMessage id="listing.setPolicyName" defaultMessage="Policy Name" />}
        >
          <Input type="text" onChange={setPolicyName} value={name} />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={<FormattedMessage id="listing.international" defaultMessage="International" />}
        >
          <Select onChange={setInternationalDays} value={internationalDays}>
            {keys(returnPolicyList).map(optionKey => (
              <Option key={optionKey} value={optionKey}>
                {returnPolicyList.get(optionKey)}
              </Option>
            ))}
          </Select>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={<FormattedMessage id="listing.domestic" defaultMessage="Domestic" />}
        >
          <Select onChange={setDomesticDays} value={domesticDays}>
            {keys(returnPolicyList).map(optionKey => (
              <Option key={optionKey} value={optionKey}>
                {returnPolicyList.get(optionKey)}
              </Option>
            ))}
          </Select>
        </FormItem>
        <Row style={{ justifyContent: 'flex-end', marginTop: '40px' }}>
          <Button
            htmlType="submit"
            type="normal"
            clickHandler={this.handlePolicy}
            disabled={isButtonDisabled}
            cssProps={{ marginRight: '5px' }}
          >
            {intl.formatMessage({
              id: isCreateAction ? 'listing.createPolicy' : 'common.save',
            })}
          </Button>
          <Button type="normal" clickHandler={close}>
            {intl.formatMessage({ id: 'common.cancel' })}
          </Button>
        </Row>
      </Fragment>
    );
  }
}

ReturnForm.propTypes = {
  ebayReturnPolicies: PropTypes.object,
  isCreateAction: PropTypes.bool,
  intl: PropTypes.object,
  close: PropTypes.func,
};
